import React from 'react'
import ReactDOM from 'react-dom'
import SortableListPersistence from './SortableListPersistence'

// Base class for implementing a sortable table class of your own. This class
// does all the work of managing data, sorting it, reversing it, optionally
// filtering it, and calling out to your component to re-render it with the
// correctly sorted data.
export default class SharedSortableLists {
  constructor({ data, sortScope, selector, statuses, roleType, beforeRender }) {
    this.data = data;
    this.sortScope = sortScope;
    this.selector = selector;
    this._container = $(selector);
    this.statuses = statuses;
    this.roleType = roleType;
    this.beforeRender = beforeRender;
    this.registerListeners();
    this.persistence = new SortableListPersistence({
      objectref: `${sortScope}-${selector}`
    })
    this.sortKey = this.persistence.getSortKey() || this.defaultSortKey();
    this._reverseList = {};
    this.setReverseList();
  }

  registerListeners() {
    N2.handle("click", `${this.sortScope} .js-sort-table-content`, (e) => {
      e.preventDefault();
      let $target = $(e.currentTarget);
      this.setSortKey($target.data("title"));
      $target.parent().find(".material-icons:not(.d-none)").addClass("d-none")
      $target.children(".text-right").children().removeClass("d-none")
      this.render()
    })

    N2.handle("click", `.js-reverse-sort${this.sortScope.replace("#", ".")}`, (e) => {
      this.setDirection()
      this.render()
    })
  }

  setReverseList(bool) {
    let val = bool == undefined ? null : bool
    this._reverseList[this.sortKey] = val
  }

  getReverseList() {
    return this._reverseList[this.sortKey]
  }

  // Main workhorse of the list, this gets called on sort or direction change,
  // as setup by registerListeners().
  render() {
    if (this.beforeRender) { this.beforeRender(this) }
    this.renderList(this.sortData())
  }

  // Optionally override to manually handle re-rendering your sorted list.
  renderList(sortedData) {
    const TableComponent = this.reactTableComponent();

    ReactDOM.render(
      <TableComponent data={sortedData} {...this.reactTableExtra()} />,
      $(this._container)[0])
  }

  // Return a React component in your subclass that will be re-rendered to the
  // selector element on sort/direction/filter change.
  reactTableComponent() {
    console.warn("You must implement reactTableComponent in your subclass of SharedSortableLists.")
    return null;
  }

  // Optionally provide extra attrs to your sortable table, beyond the sorted
  // data.
  reactTableExtra() {
    return {};
  }

  setSortKey(key) {
    this.persistence.setSortKey(key)
    this.sortKey = key;
  }

  setDirection() {
    let dir = this.getReverseList() ? false : true
    this.setReverseList(dir)
  }

  reverse(r) {
    return (r ? -1 : 1);
  }

  compare(k1, k2, reverse) {
    let c
    if (k1 > k2) {
      c = 1;
    } else if (k1 < k2) {
      c = -1;
    } else if (k1 == k2) {
      c = 0;
    } else {
      // Put incomparable items last
      c = 1;
    }

    return c * this.reverse(reverse);
  }

  // Define ways of sorting data in your subclass.
  //
  // sortData() {
  //   return this.sortBy({ attr: "client_name" })
  //   // or
  //   return this.sortMulti([{ attr: "client_name" }, {attr: "business_name"}])
  // }
  sortData() {
    return this.data;
  }

  sortBy({ attr, reverse }) {
    let reverseList = this.getReverseList();
    let reverseSetting = reverseList == null ? ( reverse || false ) : reverseList;
    if (reverse && reverseList == null ) { this.setReverseList(reverse) }
    const sorted = this.data.sort((obj1, obj2) => {
      let key = attr;
      if (obj1[key] != obj2[key]) {
        return this.compare(obj1[key], obj2[key], reverseSetting);
      } else {
        return this.compare(obj1.index, obj2.index, false);
      }
    });
    return sorted;
  }

  // Allow sorting fallbacks, when a primary sort matches. e.g. sort by client
  // name; if matching sort by date; if matching sort by status.
  sortMulti(sorts) {
    let reverseList = this.getReverseList();
    var opts, key, reverse;
    const sortedMulti = this.data.sort((obj1, obj2) => {
      for (var i = 0; i < sorts.length; i++) {
        opts = sorts[i];
        key = opts.attr;
        reverse = reverseList == null ? ( opts.reverse || false ) : reverseList;
        // reverseNever keeps something like due_at_raw always sorted
        // by the most overdue to the least
        reverse = opts.reverseNever ? false : reverse
        if (opts.reverse && reverseList == null ) { this.setReverseList(opts.reverse) }
        if (obj1[key] != obj2[key]) {
          return this.compare(obj1[key], obj2[key], reverse);
        }
      }
    })

    return sortedMulti;
  }
}
